import { Box, BoxProps, freddyTheme } from '@coolblue-development/freddy';

type Props = BoxProps & {
  iconLabel: string;
};

export const TooltipContainer = ({ iconLabel, ...props }: Props) => (
  <Box
    {...props}
    sx={{
      position: 'relative',
      cursor: 'pointer',
      display: 'inline-flex',
      textDecoration: 'none',

      '&:after': {
        content: `'${iconLabel}'`,
        position: 'absolute',
        top: `calc(100% + ${freddyTheme.spacing[200]})`,
        padding: `${freddyTheme.spacing[100]} ${freddyTheme.spacing[200]}`,
        marginLeft: freddyTheme.spacing[100],
        borderRadius: freddyTheme.borderRadius[100],
        backgroundColor: freddyTheme.color.background.backdropSubtle,
        color: freddyTheme.color.background.interactiveControlBase,
        fontSize: freddyTheme.typography.fontSize.xs,
        whiteSpace: 'nowrap',
        visibility: 'hidden',
        opacity: 0,
        transition: 'all 0.2s ease',
        zIndex: 100,
        textDecoration: 'none',
        pointerEvents: 'none'
      },

      '&:hover': {
        '&::after': {
          visibility: 'visible',
          opacity: 1
        }
      }
    }}
  >
    {props.children}
  </Box>
);
